import { useMutation, useQueryClient } from '@tanstack/react-query';
import { Endpoint } from '@/Config/api/endpoint';
import { DeepPartial } from '@/Config/types/DeepPartial';
import { ConversationApi } from '@/Domain/api/Conversation/Conversation.api';
import { ConversationDto } from '@/Domain/api/Conversation/dto/Conversation.dto';

export const useUpdateConversation = (conversationId: string) => {
  const queryClient = useQueryClient();

  const mutation = useMutation<ConversationDto, unknown, DeepPartial<Omit<ConversationDto, 'id'>>>({
    mutationKey: [Endpoint.conversation.update, conversationId],
    mutationFn: (data: DeepPartial<ConversationDto>) =>
      ConversationApi.update(conversationId, data),
    onSuccess: (data) => {
      queryClient.setQueryData<ConversationDto>([Endpoint.conversation.get, conversationId], data);
    },
  });

  const handleUpdate = (data: DeepPartial<ConversationDto>) => mutation.mutate(data);

  return {
    handleUpdate,
    isPending: mutation.isPending,
  };
};
